import { useQuery } from '@tanstack/react-query';
import { getEthnicities } from '@uplift/api';
import { CheckboxGroupOption, } from '@uplift/ui-v2';
import { PROFILE_ROW_QUERY_KEYS } from '../profile.utils';
import { PreferenceForm } from './PreferenceForm.component';

export type EthnicityFormProps = {
  hideLabel?: boolean;
  includePreferNotToSay?: boolean;
};

export const EthnicityForm: React.VFC<EthnicityFormProps> = props => {
  const { data: ethnicities = [] } = useQuery(PROFILE_ROW_QUERY_KEYS.ethnicity, async () => {
    const response = await getEthnicities();

    return response.data;
  });

  const normalizedOptions: CheckboxGroupOption[] = ethnicities.map(({ name, id }) => ({
    label: name,
    value: id,
  }));

  return (
    <PreferenceForm
      name="ethnicities"
      formOptions={normalizedOptions}
      includePreferNotToSay={props.includePreferNotToSay}
    />
  );
};
